import { Component, input, model, ChangeDetectionStrategy } from '@angular/core';

import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'csl-select-column-filter',
  standalone: true,
  imports: [SelectModule, FormsModule],
  templateUrl: './select-column-filter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './select-column-filter.component.css',
})
export class SelectColumnFilterComponent {
  filterOptions = input<{ label: string; value: any; icon?: string; colorClass?: string }[]>();
  filter = model.required<any>({
    alias: 'filterValue',
  });
  showClear = model<boolean>(true);

}
